import * as React from "react";
import { ModalBox, TitleModal } from "./styled/DialogWrapper.styled";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import { IoClose } from "react-icons/io5";
import StyledButton from "./elements/StyledButton";

const StyledDialogTitle = (props) => {
  const { children, onClose, ...other } = props;
  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other} style={{alignItems: 'center', display: 'flex', justifyContent: 'space-between', padding: '0px',}}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            color: (theme) => theme.palette.grey[500],
            zIndex: 1000
          }}
        >
          <IoClose />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

export default function DialogWrapper({
  children,
  cancelLabel,
  actionLabel,
  acceptButton,
  actionRed,
  nonAction,
  cancelAction,
  title,
  version,
  disable = false,
  isMaxWidthEnable = false,
  isSiteRefModal = false,
  ...props
}) {
  const handleClose = () => {
    cancelAction();
  };

  const modalBoxStyle = isSiteRefModal ? { isSiteRefModal: true } : {};

  return (
    <ModalBox {...props} version maxWidth={isMaxWidthEnable ? 'md' : false} {...modalBoxStyle}>
      <StyledDialogTitle onClose={handleClose}>
       {title && <TitleModal>{title}</TitleModal>} 
      </StyledDialogTitle>
      <DialogContent dividers>{children}</DialogContent>
      {!nonAction && (
        <>
          <DialogActions>
            <StyledButton
              variant={"outlined"}
              size={"small"}
              onClick={() => {
                cancelAction();
              }}
            >
              {cancelLabel}
            </StyledButton>
            {actionLabel && (
              <StyledButton
                variant={"contained"}
                size={"small"}
                onClick={acceptButton}
                //color={actionRed ? "error" : null}
                disabled={disable}
                data-testid="DialogWrapper-btn-test"
              >
                {actionLabel}
              </StyledButton>
            )}
          </DialogActions>
        </>
      )}
    </ModalBox>
  );
}
